
import { useState, useEffect } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    
    // Set initial value
    setMatches(media.matches);
    
    // Create listener function
    const listener = () => setMatches(media.matches);
    
    // Start listening for changes
    media.addEventListener("change", listener);
    
    // Clean up listener on unmount
    return () => media.removeEventListener("change", listener);
  }, [query]);

  return matches;
}
